import { format } from 'utils/stringUtilities'

export const deletedListActionProps = (props) => ({
  onDelete: x => props.hardDelete(x),
  deleteButtonTooltip: props.localize('common.hardDeleteEntity'),
  confirmMessage: (x, nameGetter = x => x.name) => format(props.localize('common.confirmHardDelete'), nameGetter(x)),
  onRestore: x => props.restore(x.id)
})

export const listActionProps = (props) => ({
  onDelete: x => props.delete(x),
  confirmMessage: (x, nameGetter = x => x.name, isSoftDelete) => format(props.localize(isSoftDelete ? 'common.confirmDelete' : 'common.confirmHardDelete'), nameGetter(x))
})

